export enum LootboxOpenStep {
  start,
  inProgress,
  blockchainConfirmation,
  finished,
  failed,
}
